export const COLUMNS = 'columns';

export const dragColumnParams = {
	ignoreSelector: '.react-resizable-handle',
	nodeSelector: 'th',
	handleSelector: '.dragHandler',
};
